export const todayGroupHeader = "dCm_kd";
export const yesterdayGroupHeader = "STBPS";
export const thisWeekGroupHeader = "Kb_beb";
export const lastWeekGroupHeader = "SbQ65b";
export const thisMonthGroupHeader = "Yunzbe";
export const lastMonthGroupHeader = "GZ2HSb";
export const olderGroupHeader = "oV3RWd";
export default {todayGroupHeader,yesterdayGroupHeader,thisWeekGroupHeader,lastWeekGroupHeader,thisMonthGroupHeader,lastMonthGroupHeader,olderGroupHeader};